import React from 'react';
import { formatCurrency } from '../../utils/helpers';
import './WalletCard.css';

export const WalletCard = ({
    rechargeBalance = 0,
    withdrawBalance = 0,
    onRecharge,
    onWithdraw,
}) => {
    const totalBalance = rechargeBalance + withdrawBalance;

    return (
        <div className="wallet-card">
            {/* Total Balance */}
            <div className="total-section">
                <span className="total-label">Total Balance</span>
                <span className="total-amount">{formatCurrency(totalBalance)}</span>
            </div>

            {/* Balance Details */}
            <div className="balance-row">
                <div className="balance-item">
                    <div className="balance-header">
                        <span className="material-icons balance-icon">account_balance_wallet</span>
                        <span className="balance-label">Recharge</span>
                    </div>
                    <span className="balance-amount">{formatCurrency(rechargeBalance)}</span>
                </div>

                <div className="balance-divider"></div>

                <div className="balance-item">
                    <div className="balance-header">
                        <span className="material-icons balance-icon">payments</span>
                        <span className="balance-label">Withdraw</span>
                    </div>
                    <span className="balance-amount">{formatCurrency(withdrawBalance)}</span>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="action-row">
                <button className="action-button" onClick={onRecharge}>
                    <span className="material-icons">add_circle</span>
                    <span>Recharge</span>
                </button>
                <button className="action-button" onClick={onWithdraw}>
                    <span className="material-icons">account_balance</span>
                    <span>Withdraw</span>
                </button>
            </div>
        </div>
    );
};

export default WalletCard;
